import api from './api';

export const fetchNotifications = async (params = {}) => {
  // params: { unreadOnly, page, limit }
  const res = await api.get('/notifications', { params });
  return res.data; // { notifications, unreadCount, total, page, limit }
};

export const markNotificationRead = async (id) => {
  const res = await api.patch(`/notifications/${id}/read`);
  return res.data;
};

export const markAllNotificationsRead = async () => {
  const res = await api.patch('/notifications/read-all');
  return res.data;
};